import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const IncidentModalWrapper = styled(Modal)`
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    &:hover{
      opacity: 0.8;
    }
  }
  .ant-btn-primary{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    &:hover,
    &:focus{
      background-color: #0B2A1B;
      border-color: #0B2A1B;
      opacity: 0.8;
    }
  }
  .ant-modal-body{
    padding: 0;
  }
  .form-title{
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3{
      font-size: 1rem;
    }
  }
  .form-body{
    padding: 12px 24px 12px 24px;
    .checkbox-contact{
      margin-bottom: 10px;
    }
  }
  a,.ant-upload .ant-btn:hover,.ant-upload .ant-btn:focus{
    border-color: #0B2A1B;
    color:#0B2A1B
  }
  &.mob-cannot-create .ant-btn-primary{
    display: none;
  }
  .btn-create-breed{
    background-color: #46AFCA;
    border-color: #46AFCA;
    &:hover{
      opacity: 0.8;
    }
    margin-top:30px;
    width: 100%;
    padding: 0;
  }
  .card_content{
    display:inline;
  }

  .card_value{
    float:right;
  }

  .incident-type-option {
    display: flex;
    flex-direction: column;
    line-height: 1.3;
  }

  .incident-type-label {
    font-weight: 500;
    color: #101828;
  }

  .incident-type-description {
    font-size: 12px;
    color: #667085;
  }

  .incident-type-help {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    color: #667085;
  }

  .ant-select-selector {
    border-color: #0B2A1B !important;
    box-shadow: none;
    outline: none;
  }

  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: #0B2A1B;
  }

  .ant-select-focused .ant-select-selector,
  .ant-select-selector:focus,
  .ant-select-selector:active,
  .ant-select-open .ant-select-selector {
    border-color: #0B2A1B !important;
    box-shadow: 0 0 0 2px #faf5c8;
    outline: none;
  }

  .ant-select-selection-search-input:focus {
    outline: none;
    box-shadow: 0 0 0 2px #faf5c8;
  }

  .ant-input,
  .ant-input-number,
  .ant-input-affix-wrapper {
    border-color: #0B2A1B;
    box-shadow: none;
    outline: none;
  }

  .ant-input:focus,
  .ant-input-focused,
  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper:focus,
  .ant-input-number-focused,
  .ant-input-number:focus,
  .ant-select:focus,
  .ant-select-focused {
    border-color: #0B2A1B !important;
    box-shadow: 0 0 0 2px #faf5c8;
    outline: none;
  }

  .ant-select-focused,
  .ant-select:focus {
    outline: none !important;
  }

  .ant-select-selector:focus-visible,
  .ant-select-selection-search-input:focus-visible {
    outline: none !important;
    box-shadow: 0 0 0 2px #faf5c8 !important;
  }

  .primary-objects-tooltip{
    background: transparent;
    color: white;
    border: none;
    box-shadow: none;
  }
`;

export default WithDirection(IncidentModalWrapper);
